import { render, staticRenderFns } from "./RiCoHelpList.vue?vue&type=template&id=9c75c31e&"
import script from "./RiCoHelpList.vue?vue&type=script&lang=js&"
export * from "./RiCoHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports